import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

const EventContent = (eventInfo: any) => {
  // const getRandomColor = (): string => {
  //   const letters = "0123456789ABCDEF";
  //   let color = "#";
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };
  // const circleColor = getRandomColor();

  // Extract id and title from eventInfo
  const id = `event-tooltip-${eventInfo.event.event_id}`;

  return (
    <OverlayTrigger
    placement="top"
      overlay={
        <Tooltip
          id={id}
          style={{
            backgroundColor: "black",
            color: "white",
            fontSize: "0.75rem", // text-sm equivalent
            padding: "0.5rem",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
            zIndex: "1073"
          }}
        >
          {eventInfo.event.title}
        </Tooltip>
      }
    >
      <span className="flex align-content-center">
        {/* {eventInfo.timeText && (
          <span className={"ml-1"}>
            {eventInfo.timeText && eventInfo.timeText + "m"}
          </span>
        )} */}
        {eventInfo.event.extendedProps.type === "event" ? (
          <Link
            to={`view/${eventInfo.event.extendedProps.event_id}`}
            style={{ color: "#fff" }}
          >
            <b
              className="mx-1 text-truncate"
              style={{
                maxWidth: "150px",
                display: "inline-block",
                color: "#fff",
              }}
              title={eventInfo.event.title}
            >
              {eventInfo.event.title}
            </b>
          </Link>
        ) : (
          <b
            className="mx-1 text-truncate"
            style={{ maxWidth: "150px", display: "inline-block" }}
            title={eventInfo.event.title}
          >
            {eventInfo.event.title}
          </b>
        )}
      </span>
    </OverlayTrigger>
  );
};

export default EventContent;
